import { render, staticRenderFns } from "./MeusContratos.vue?vue&type=template&id=37245ff4"
import script from "./MeusContratos.vue?vue&type=script&lang=js"
export * from "./MeusContratos.vue?vue&type=script&lang=js"
import style0 from "./MeusContratos.vue?vue&type=style&index=0&id=37245ff4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports